import React from "react";
import { makeStyles } from "@material-ui/core";

let useStyles = makeStyles((theme) => ({
    container: {
        width: "100%",
        height: 400,
        overflow: "hidden",
        position: "relative",
        [theme.breakpoints.down('380')]: {
            height: 450,
        }
    },

    bg: {
        "animation-delay": '0s',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        animation: '$slideIn 2s linear infinite',
        // backgroundImage: `url(/assets/images/bg_plus.png)`,
        backgroundImage: 'linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(246,246,246,0) 50%, rgba(255,255,255,1) 100%), url(/assets/images/bg_plus.png);',
        backgroundRepeat:'repeat-x',
        backgroundSize: 'cover',
        padding: '25px 0px',
    },
    root: {
        ...theme.grid.gridMdContent,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        textAlign: 'center',
        flexDirection: 'column',
        margin: '70px auto',
        maxWidth: '100%',
        position: 'relative',
    },
    gridDesc: {
        width: '50%',
        minWidth: 700,
        maxWidth: '100%',
        margin: 'auto',
        [theme.breakpoints.down("800")]: {
            minWidth: '100%',
        },
    },
    desc: {
        margin: 0,
        fontSize: 16,
    },
    title: {
        fontSize: 30,
        whiteSpace: 'nowrap',
        fontWeight: 700,
        marginBottom: 20,
        [theme.breakpoints.down('1500')]: {
            fontSize: 30,
        },
        [theme.breakpoints.down('500')]: {
            whiteSpace: 'normal',
            width: '100%',
            margin: 'auto',
            textAlign: 'center'
        }
    },
    line: {
        borderRadius: 3,
        height: 4,
        border: 'none',
        backgroundColor: theme.palette.light.type2,
        position: 'absolute',
        top: -10,
        left: '50%',
        width: 30,
        [theme.breakpoints.down('1135')]: {
            top: -10,
            display: 'none'
        },
    },

    gridBtns: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        margin: '45px auto 0px auto',
        '& > a': {
            [theme.breakpoints.down('500')]: {
                width: '100%',
                marginBottom: 10,
            },
        },
    },
    btnWhite: {
        padding: '0px 33.5px',
        fontSize: 16,

        [theme.breakpoints.down('500')]: {
            width: '100%'
        },
    },
    btnRed: {
        margin: 5,
        fontSize: 16,
        padding: '0px 22.3px',
        [theme.breakpoints.down("500")]: {
            width: '100%',
            margin: 0,
        },
    },

    '@keyframes slideIn': {
        "0%": {
            // opacity: 0, /* Start with opacity 0 */
            transform: 'translateY(-10%)',
        },
        "20%": {
            // opacity: 1, /* Fade in */

        },
        "95% ": {
            // opacity: 1, /* Stay visible */
            // transform: 'translateY(0)',
        },
        "100%": {
            // transform: 'translateY(0)',
            // opacity: 0, /* Fade out */
        }
    },




    "scrolling-image-container": {
        overflow: "hidden",
        height:0,
    },
    "scrolling-image": {
        // background: url("./background-image.jpg") repeat-x;
        backgroundImage: 'linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(246,246,246,0) 50%, rgba(255,255,255,1) 100%), url(/assets/images/bg_plus.png);',
        backgroundRepeat:'repeat-x',
        height:"750px",
        width: "100%",
        // backgroundColor:'red',
        // animation: "slide2 3s linear infinite"
        animation: '$slide2 5s linear infinite',
    },

}))

export default function Index() {

    let classes = useStyles();

    return (
        <div className={classes['container']}>
            <div className={`${classes['bg']} `}> </div>
            <div className={classes['root']}>
                <div>

                    <div className={classes['line']} />
                    <h3 className={classes['title']}>
                        دریافت کد بورسی و مشاوره
                    </h3>
                </div>
                <div className={classes['gridDesc']}>
                    <p className={classes['desc']}>
                        شما می‌توانید به راحتی و به صورت رایگان، بدون نیاز به حضور شخصی، کد بورسی خود را از کارگزاری پویان دریافت کنید. همچنین، اگر نیاز به راهنمایی دارید، می‌توانید با تماس و مشاوره رایگان، از تخصصی‌ترین مشاوران سرمایه‌گذاری پویان بهره‌مند شوید.

                    </p>

                </div>
                <div className={classes['gridBtns']}>
                    {/* <a href="https://pouyan.ebgo.ir/StockCode" target={'_blank'}> */}
                    <a href="https://reg.pouyanbroker.com" target={'_blank'}>
                        <button type="" className={`${classes['btnRed']} btnPouyanRed`}>
                            دریافت کد بورسی
                        </button>
                    </a>
                    <a href="tel:02191005777">
                        <button type="" className={`${classes['btnWhite']} btnPouyanWhite`}>
                            تماس و مشاوره
                        </button>
                    </a>
                </div>
            </div>
        </div>
    )
}
